import React from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { useTheme } from 'emotion-theming';
import { Box, Card, Flex, Hide } from 'roo-ui/components';
import PulsingLoadingBlock from 'components/PulsingLoadingBlock';

const SkeletonCard = styled(Card)`
  opacity: 0.6;
  overflow: hidden;
  box-shadow: ${themeGet('shadows.result')};
`;

SkeletonCard.displayName = 'SkeletonCard';

const LoaderSkeletonCard = React.memo(() => {
  const theme = useTheme();

  return (
    <SkeletonCard mb={5} p={0}>
      <Flex flexDirection={['column', 'row', 'row']}>
        <Box>
          <PulsingLoadingBlock
            mr={[0, 2]}
            mb={[2, 0]}
            height={theme.imageSizes.searchThumbnail.height}
            width={theme.imageSizes.searchThumbnail.width}
            borderRadius={0}
          />
        </Box>

        <Box p={4}>
          <Hide sm md lg>
            <PulsingLoadingBlock height={20} width={260} />
            <Flex justifyContent="flex-start">
              <PulsingLoadingBlock height={14} width={100} />
              <PulsingLoadingBlock height={14} width={120} />
            </Flex>
            <PulsingLoadingBlock height={14} width={90} />
          </Hide>
          <Hide xs>
            <PulsingLoadingBlock height={20} width={260} mt={8} />
            <PulsingLoadingBlock height={14} width={100} />
            <Flex justifyContent="flex-start">
              <PulsingLoadingBlock height={14} width={90} />
              <PulsingLoadingBlock height={14} width={180} />
            </Flex>
          </Hide>
        </Box>
        <Flex p={4} flex="1 1 auto" flexDirection="column" alignItems={'flex-end'}>
          <Hide xs sm md>
            <Flex flex="1 1 auto" flexDirection="column" alignItems={['flex-start', 'flex-end', 'flex-end']} mt={8}>
              <PulsingLoadingBlock height={14} width={120} />
              <PulsingLoadingBlock height={20} width={80} />
              <PulsingLoadingBlock height={14} width={160} />
            </Flex>
          </Hide>
        </Flex>
      </Flex>
    </SkeletonCard>
  );
});

LoaderSkeletonCard.displayName = 'LoaderSkeletonCard';

export default LoaderSkeletonCard;
